export default {
  name: 'EXPENSE_SYNC_MODULE',
  namespaced: true,
  state: {
    lastSyncTime: null,
    lastSyncResult: null,
    isSyncing: false,
    syncError: null,
    syncHistory: []
  },
  getters: {
    lastSyncTime: state => state.lastSyncTime,
    lastSyncResult: state => state.lastSyncResult,
    isSyncing: state => state.isSyncing,
    syncError: state => state.syncError,
    syncHistory: state => state.syncHistory
  },
  mutations: {
    SET_SYNCING(state, isSyncing) {
      state.isSyncing = isSyncing;
    },
    SET_SYNC_RESULT(state, result) {
      state.lastSyncResult = result;
      state.lastSyncTime = new Date().toISOString();
      state.syncError = null;

      // Add to history
      if (result) {
        state.syncHistory.unshift({
          time: state.lastSyncTime,
          success: result.success,
          message: result.message,
          createdCount: result.createdCount,
          skippedCount: result.skippedCount,
          errorCount: result.errorCount
        });

        // Keep only last 10 sync attempts
        if (state.syncHistory.length > 10) {
          state.syncHistory = state.syncHistory.slice(0, 10);
        }
      }
    },
    SET_SYNC_ERROR(state, error) {
      state.syncError = error;
      state.lastSyncResult = null;
      state.isSyncing = false;
    },
    CLEAR_SYNC_ERROR(state) {
      state.syncError = null;
    },
    CLEAR_SYNC_HISTORY(state) {
      state.syncHistory = [];
    }
  },
  actions: {
    async syncExpenseTypes(context, branchId) {
      try {
        context.commit('SET_SYNCING', true);
        context.commit('CLEAR_SYNC_ERROR');

        const apiKey = context.rootGetters.getterApikey;

        if (!apiKey) {
          throw new Error('API Key is missing. Please log in again.');
        }

        const url = `${window.pettyCashApi}api/expense-types/sync/${branchId}`;

        const response = await window.axios.post(url, {}, {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey
          }
        });

        if (response.data && response.data.success) {
          context.commit('SET_SYNC_RESULT', response.data);

          // Show success notification
          const created = response.data.createdCount || 0;
          const skipped = response.data.skippedCount || 0;
          const errors = response.data.errorCount || 0;

          let message = `Sync completed: ${created} created, ${skipped} skipped`;
          if (errors > 0) {
            message += `, ${errors} errors`;
          }

          window.Swal.fire({
            title: 'Success',
            text: message,
            icon: 'success'
          });

          // Refresh expense types list
          await context.dispatch('fetchAllExpenseTypes', {}, { root: true });

          return response.data;
        } else {
          throw new Error(response.data?.message || 'Failed to sync expense types');
        }
      } catch (error) {
        const errorMessage = error.message || 'Failed to sync expense types from Lytning';
        context.commit('SET_SYNC_ERROR', errorMessage);

        // Show error notification
        window.Swal.fire({
          title: 'Sync Failed',
          text: errorMessage,
          icon: 'error'
        });

        window.errorHandler.tomcatError(error);
        throw error;
      } finally {
        context.commit('SET_SYNCING', false);
      }
    },

    clearSyncHistory(context) {
      context.commit('CLEAR_SYNC_HISTORY');
    }
  }
};
